import AutoResponderMixin from "../../../mixins/auto-responder-mixin";

Vue.component("auto-responder", {
    mixins: [ AutoResponderMixin ],
    props: {
        autoResponder: {
            default: null,
            description: "mailbox auto responder object"
        },
        mailbox: {
            type: Object,
            default: () => {
                return {};
            },
            description: "selected mailbox"
        }
    },
    data() {
        return {
            form: new AppForm(this.setForm()),
            activeUntilOptions: {
                disabledDate (date) {
                    return date < new Date();
                }
            },
            editorOption: {
                modules: {
                    toolbar: "#auto-responder-toolbar"
                }
            },
            attachmentRequestHeaders: window.axios.defaults.headers.common,
            attachments: this.autoResponder.media,
        }
    },
    watch: {
        autoResponder() {
            this.form = new AppForm(this.setForm());
            this.attachments = this.autoResponder.media;
        }
    },
    computed: {
        canChangeAutoresponder () {
            return this.userCan("manage-mailboxes");
        }
    },
    methods: {
        onEditorReady (editor) {
            $("#toolbar").find(":button").attr("tabindex", "-1");
            $(".ql-picker-label").attr("tabindex", "-1");
            editor.on("text-change", (delta, oldDelta, source) => {
                $(".ql-editor img").remove();
            });
        },
        setForm() {
            return this.autoResponder === null
                ? {
                    status: false,
                    mailbox_id: this.mailbox.id,
                    body: '',
                    active_until: null
                }
                : this.autoResponder;
        },
        formSubmit() {
            if(this.autoResponder === null) {
                this.createAutoResponder();
            } else {
                this.updateAutoResponder();
            }
        },
        createAutoResponder() {
            App.post(`settings/autoresponders/store`, this.form)
                .then(response => {
                    window.toastr.success("Auto reply has been updated successfully!");
                    this.$emit('auto-responder-updated', response.autosesponder, this.mailbox.id);
                })
                .catch(error => {
                    window.toastr.error("An error occurred while updating the auto reply!");
                });

        },
        updateAutoResponder() {
            App.patch(`settings/autoresponders/${this.autoResponder.id}/mailbox/${this.mailbox.id}`, this.form)
                .then(response => {
                    window.toastr.success("Auto reply has been updated successfully!");
                    this.$emit('auto-responder-updated', response.autosesponder, this.form.mailbox_id);
                })
                .catch(error => {
                    window.toastr.error("An error occurred while updating the auto reply!");
                });
        }
    }
});
